import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';

import OutputText from '@ey/canvascoreservices/OutputText';
import {useHistory, useLocation} from 'react-router-dom';

import {labels} from '../../../../../util/utils';
import {componentsTabId, groupRiskStatus, componentAccountsPropNames} from '../../../../../util/uiconstants';
import Utility from '../../../../../util/utilityfunctions';
import {updateReconciliationAccount} from '../../../../../actions/Reconciliations';
import Badge from '../../../../CoreWrappers/Badge';
import Modal from '../../../../CoreWrappers/Modal';
import TabNavigation from '../../../../CoreWrappers/TabNavigation';
import HrAlt from '../../../../Common/Hr/HrAlt';
import {IconoirWarningTriangle} from '@ey-xd/motif-icon';

import StyledTrigger from '../UnmappedRisksModal/StyledTrigger';
import ComponentAccountsTable from '../../../../Common/ComponentAccountsTable';
import StyledComponentAccountsModal from './StyledComponentAccountsModal';
import selectProjectAndEngIds from '../../../../../reducers/Reconciliations/selectors/selectProjectAndEngIds';
import selectUnmappedComponentAccounts from '../../../../../reducers/Reconciliations/selectors/selectUnmappedComponentAccounts';

const ComponentAccountsModal = () => {
	const dispatch = useDispatch();
	const [show, setShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [activeTab, setActiveTab] = useState(null);
	const onHide = () => setShow(false); //TODO: onHide should remove the hash on the URL.
	const history = useHistory();
	const location = useLocation();
	const apiConfig = selectProjectAndEngIds();
	const componentAccounts = selectUnmappedComponentAccounts();

	const {notRelated, notApplicable} = componentAccountsPropNames;

	const renderTrigger = () => {
		const props = {
			size: 'small',
			variant: 'text-alt',
			label: labels.viewComponentTeamAccountsText,
			svg: IconoirWarningTriangle,
			onClick: () => {
				setShow(true);
			}
		};

		return (
			<StyledTrigger {...props}>
				<Badge value={componentAccounts?.length} />
			</StyledTrigger>
		);
	};

	const tabs = [
		{
			id: componentsTabId.NotRelated,
			label: labels.notRelatedTab,
			hash: `#${notRelated}`,
			visible: true,
			View: ComponentAccountsTable
		},
		{
			id: componentsTabId.NotApplicable,
			label: labels.notApplicableTab,
			hash: `#${notApplicable}`,
			visible: true,
			View: ComponentAccountsTable
		}
	];

	useEffect(() => {
		handleHashAtLoad();
	}, []);

	const handleSetTab = (newTab) => {
		history.replace(`${location.search}${newTab.hash}`);
		setActiveTab(newTab);
	};

	const handleHashAtLoad = () => {
		const hash = location.hash;
		if (hash) {
			const hashTab = tabs.find(({hash: hashTag}) => hashTag.toLowerCase() === hash.toLowerCase());
			setActiveTab(hashTab ? hashTab : tabs[0]);
		} else {
			handleSetTab(tabs[0]);
		}
	};

	const renderTabs = () => {
		const props = {
			tabs,
			activeTab,
			setTab: handleSetTab
		};
		return <TabNavigation {...props} />;
	};

	const renderModal = () => {
		const renderInstructional = () => (
			<OutputText light>
				{Utility.createRichTextElement(
					activeTab.id === componentsTabId.NotRelated
						? labels.componentTeamAccountsModalInstructionalText
						: labels.componentTeamAccountsModalNotApplicableInstructionalText
				)}
			</OutputText>
		);

		const handlerUpdateGroupRiskStatusId = (accountId, groupRiskStatusId) => {
			const payload = {
				groupRiskStatusId
			};
			setIsLoading(true);
			dispatch(updateReconciliationAccount(accountId, payload, apiConfig)).then(() => {
				setIsLoading(false);
			});
		};

		const props = {
			show,
			modalsize: 'medium',
			title: labels.componentTeamAccountsModalTitle,
			labels: {
				modalCancelBtnLabel: labels.closeLabel,
				modalCloseBtnTitletip: labels.closeLabel,
				modalConfirmBtnLabel: labels.closeLabel
			},
			hideCancelButton: true,
			onOkClick: () => onHide(),
			onClose: () => onHide(),
			isOkDisabled: isLoading,
			disableClose: isLoading,
			isLoading
		};

		let tabProps;

		if (activeTab === null || activeTab.id === componentsTabId.NotRelated) {
			tabProps = {
				items: componentAccounts?.filter(({groupRiskStatusId}) => groupRiskStatusId === groupRiskStatus.unmapped) || [],
				action: (accountId) => handlerUpdateGroupRiskStatusId(accountId, groupRiskStatus.notApplicable),
				labelPropName: notRelated
			};
		} else {
			tabProps = {
				items:
					componentAccounts?.filter(({groupRiskStatusId}) => groupRiskStatusId === groupRiskStatus.notApplicable) || [],
				action: (accountId) => handlerUpdateGroupRiskStatusId(accountId, groupRiskStatus.unmapped),
				labelPropName: notApplicable
			};
		}

		return (
			show && (
				<Modal {...props}>
					<StyledComponentAccountsModal>
						{renderInstructional()}
						<HrAlt $color="--neutrals-200" />
						{renderTabs()}
						{activeTab && <activeTab.View {...tabProps} />}
					</StyledComponentAccountsModal>
				</Modal>
			)
		);
	};

	return (
		<>
			{renderTrigger()}
			{renderModal()}
		</>
	);
};

ComponentAccountsModal.propTypes = {};

export default ComponentAccountsModal;
